import useI18n from '@/hooks/useI18n';
import { FormDataForCreateCampaign } from '@/types/interfaces';
import { getActivePlatforms } from '@/utils/socialplatformUtils';
interface CreativeBriefComponentProps {
  formData: FormDataForCreateCampaign;
}

const CreativeBriefComponent: React.FC<CreativeBriefComponentProps> = ({
  formData,
}) => {
  const { t } = useI18n();
  const activePlatforms = getActivePlatforms(formData);

  return (
    <div className="p-4 gap-[20px] flex flex-col">
      <div className="flex gap-4 items-center">
        <div className="w-[32px] h-[32px] bg-[#06B217] text-white rounded-full text-2xl text-center">
          5
        </div>
        <span className="text-[#172B4D] text-base font-semibold">
          {t('common.creativeBrief')}
        </span>
      </div>
      {/* <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.contentTitle')}
        </span>
        <div className="text-[#292828] text-lg font-normal">
          {formData?.contentTitle}
        </div>
      </div>{' '} */}
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.contentDescription')}
        </span>
        <div
          className="text-[#292828] text-lg font-normal  break-all
    max-w-full"
        >
          {formData?.contentDescription}
        </div>
      </div>
      <div>
        <span className="text-[#9B919D] text-sm font-normal">
          {t('common.hashtagToBeUsed')}
        </span>
        <div
          className="text-[#292828] text-lg font-normal  break-all
    max-w-full"
        >
          {formData?.hashtags?.map((item) => {
            return (
              <label key={item} className="inline-flex mr-2 ">
                {item}
              </label>
            );
          })}
        </div>
      </div>
      {activePlatforms.instagram && (
        <div>
          <span className="text-[#9B919D] text-sm font-normal">
            {t('common.tagToBeUsedByInstagram')}
          </span>
          <div
            className="text-[#292828] text-lg font-normal  break-all
    max-w-full"
          >
            {formData?.instagramTags?.map((item) => {
              return (
                <label key={item} className="inline-flex mr-2">
                  {item}
                </label>
              );
            })}
          </div>
        </div>
      )}
      {activePlatforms.tiktok && (
        <div>
          <span className="text-[#9B919D] text-sm font-normal">
            {t('common.tagToBeUsedByTiktok')}
          </span>
          <div
            className="text-[#292828] text-lg font-normal  break-all
    max-w-full"
          >
            {formData?.tiktokTags?.map((item) => {
              return (
                <label key={item} className="inline-flex mr-2">
                  {item}
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CreativeBriefComponent;
